import env from './env'

export const CODE_QUERY_PARAM = 'oobCode'

export const MODE_QUERY_PARAM = 'mode'

export const CONTINUE_URL_QUERY_PARAM = 'continueUrl'

export const REAUTHENTICATE_QUERY_PARAM = 'reauthenticate'

export const SECURITY_QUERY_PARAM = 'changePassword'

export const DELETE_ACCOUNT_QUERY_PARAM = 'deleteAccount'

export const EXTEND_SESSION_QUERY_PARAM = 'extendSession'

export const REAUTHENTICATION_STATUS_QUERY_PARAM = 'reauthenticationStatus'

export const REAUTHENTICATION_VARIANT_QUERY_PARAM = 'reauthenticationVariant'

export const EMAIL_FOR_SIGN_IN_STORAGE_KEY = 'emailForSignIn'

export const VIEWER_MODE_STORAGE_KEY = 'viewerMode'

export const PENDING_TWO_FACTOR_ACTION_STORAGE_KEY = 'pendingTwoFactorAction'

export const SESSION_EXTENSION_RETURN_PATH_STORAGE_KEY =
  'sessionExtensionReturnPath'

export const SESSION_EXPIRY_HOLD_STORAGE_KEY = 'sessionExpiryHolds'

export const SESSION_AUTH_TIME_STORAGE_KEY = 'sessionAuthTime'

// Names of the 2FA factor saved in the user's Firebase account. Firebase may show
// them to the user. They differ by app, as the name is the only way to tell later
// which app the factor was added in.
export const BLUEBOLT_TOTP_FACTOR_DISPLAY_NAME = 'Blue Bolt Authenticator'

export const GLOBALWORTH_TOTP_FACTOR_DISPLAY_NAME =
  'Globalworth App Authenticator'

// App names shown next to the 2FA code in the authenticator app
export const BLUEBOLT_TOTP_ISSUER = 'BlueBolt'

export const GLOBALWORTH_TOTP_ISSUER = 'GlobalworthApp'

export const SYSTEM_ADMIN_SESSION_MAX_MS =
  env.systemAdminSessionMaxSeconds * 1000

export const USER_SESSION_MAX_MS = env.userSessionMaxSeconds * 1000

// The topbar shows the session countdown for this long before the session expires
export const SESSION_COUNTDOWN_MS = env.sessionCountdownSeconds * 1000

// A tab that keeps the other tabs from ending the session renews its hold this
// often, and the hold lasts this long, so the hold of a closed tab ends soon.
// It lasts over a minute, as a background tab may run its timers only once a minute.
export const SESSION_EXPIRY_HOLD_RENEWAL_MS = 30 * 1000

export const SESSION_EXPIRY_HOLD_DURATION_MS = 2 * 60 * 1000

// A tab waits for the holds of the other tabs at most this long after its
// session expires, so a tab left on the reauthentication screen can't keep the
// other tabs signed in for good. The session extension dialog keeps its own tab
// signed in for the same time.
export const SESSION_EXPIRY_HOLD_MAX_MS = 10 * 60 * 1000
